import { Colors } from "../preset.constants";

export const accordionPreset = {
    header: {
        color: Colors.DefaultTextColor,
        activeColor: Colors.DefaultTextColor,
        hoverColor: Colors.DefaultTextColor,
        background: Colors.PrimaryBackground,
        hoverBackground: Colors.PrimaryBackground,
        activeBackground: Colors.PrimaryBackground,
        activeHoverBackground: Colors.PrimaryBackground,
    },
    content: {
        color: Colors.DefaultTextColor,
        background: Colors.PrimaryBackground
    }
}